"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _excluded = ["unique"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  unique: _propTypes.string
};

var Windows = function Windows(_ref) {
  var _ref$unique = _ref.unique,
      unique = _ref$unique === void 0 ? "" : _ref$unique,
      props = _objectWithoutPropertiesLoose(_ref, _excluded);

  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    viewBox: "0 0 19 19",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react["default"].createElement("defs", {
    fill: "inherit"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    fillRule: "evenodd",
    id: "glyphs/os/windows-windows" + unique,
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/_react["default"].createElement("use", {
    fill: "inherit",
    fillRule: "nonzero",
    id: "grey600-windows" + unique,
    xlinkHref: "#path-1-windows" + unique
  }), /*#__PURE__*/_react["default"].createElement("g", {
    fill: "inherit",
    id: "colors/core/gunmetal-windows" + unique
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.5,1.5 L18.6,0 L18.6,8.9 C15.2,8.9 11.8,9 8.5,9 L8.5,1.5 Z",
    id: "path-1-windows" + unique
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8.8817842e-16,2.7 C2.5,2.3 5.1,1.9 7.7,1.7 L7.7,9 C5.1,9 2.6,9.1 -8.8817842e-16,9.1 L-8.8817842e-16,2.7 Z",
    id: "path-2-windows" + unique
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M-8.8817842e-16,9.8 C2.5,9.8 5.1,9.9 7.7,9.8 L7.7,17.2 C5.1,16.9 2.6,16.5 -8.8817842e-16,16.2 L-8.8817842e-16,9.8 Z",
    id: "path-3-windows" + unique
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8.5,9.9 L18.6,9.9 L18.6,18.8 C15.2,18.3 11.8,17.8 8.5,17.4 L8.5,9.9 Z",
    id: "path-4-windows" + unique
  }))));
};

Windows.propTypes = propTypes;
var _default = Windows;
exports["default"] = _default;